<template>
  <div class="sp_forgotPassword">
    <div class="sp_login_introduce">
      <h1>Sangfor Support Portal</h1>
      <p>Welcome to Sangfor Support Portal.</p>
      <p>At Sangfor, we aspire to make IT simpler, more secure, and valuable.</p>
      <p>This support portal is to empower our users to monitor, manage, view, activate and update their Sangfor assets. You can take charge of your assets through the user-friendly Sangfor Support
        Portal.</p>
    </div>

    <div class="sp_fp_module">
      <sangfor-logo :page="'forgotPassword'"></sangfor-logo>
      <div class="sp-fp-content">
        <p class="sp_passwordRetrieval"><span class="title">Password Retrieval</span><span class="line"></span></p>
        <el-steps :active="stepsActive"
                  finish-status="success"
                  simple
                  class="step"
                  style="margin-top: 20px">
          <el-step v-for="val in stepData"
                   :key="val.id"
                   :title="val.title"
                   @click.native="handleSteps(val.id)"
                   :class="{isActive:stepsActive == val.id}"></el-step>
        </el-steps>

        <keep-alive>
          <forgot-pas-step-one v-if="stepsActive == 1"
                               @stepOne="stepOne"
                               :forgotParams="params"></forgot-pas-step-one>
          <forgot-pas-step-two v-if="stepsActive == 2"
                               @stepTwo="stepTwo"
                               :forgotParamstwo="params"></forgot-pas-step-two>
          <forgot-pas-step-three v-if="stepsActive == 3"
                                 @stepTwo="stepThree"
                                 :forgotParamsthree="params"></forgot-pas-step-three>
        </keep-alive>
      </div>
      <div class="footer-label">
        <p class="sp_login_copyRight">Sangfor Official WebsiteSangfor Community Copyright 2021 SANGFOR TECHNOLOGIES INC.</p>
      </div>
    </div>
  </div>
</template>

<script>
import SangforLogo from '../../components/sangforLogo.vue'
import forgotPasStepOne from './forgotPasStepOne.vue'
import ForgotPasStepThree from './forgotPasStepThree.vue'
import ForgotPasStepTwo from './forgotPasStepTwo.vue'
export default {
  components: {
    forgotPasStepOne,
    ForgotPasStepTwo,
    ForgotPasStepThree,
    SangforLogo,
  },
  name: 'forgotPassword',
  data() {
    return {
      stepsActive: 1,
      params: {
        email: '',
        code: '',
        // verificationCode: ''
      },
      stepData: [
        { id: 1, title: 'Fill in Email Address' },
        { id: 2, title: 'Check Email Address' },
        { id: 3, title: 'Reset Password' },
      ],
      sendSuccess: false,
      checkSuccess: false,
    }
  },

  methods: {
    //步骤传值
    stepOne(data) {
      if (data.sendSuccess) {
        this.stepsActive = 2
        this.sendSuccess = data.sendSuccess
        this.params.email = data.email
      }
    },

    stepTwo(data) {
      console.log(data);
      if (data.checkSuccess) {
        this.stepsActive = 3
        this.checkSuccess = data.checkSuccess
        this.params.code = data.code
        // this.params.verificationCode = data.verificationCode
      }
    },

    stepThree(data) {
      if (data.isNext) {
        this.stepsActive = 3
        this.params.code = data.code
      }
    },

    //来回切换步骤
    handleSteps(data) {
      if (data == 1) {
        this.stepsActive = data
      } else if (data == 2 && this.sendSuccess) {
        this.stepsActive = data
      } else if (data == 3 && this.checkSuccess) {
        this.stepsActive = data
      } else {
        return
      }
    },
  },

  destroyed() {
    this.$ls.remove('timeOut')
  },
}
</script>

<style lang="scss" scoped>
.sp_forgotPassword {
  width: 100%;
  height: 100%;
  min-width: 1024px;
  background: url('../../assets/img/forgotPassword.jpg') no-repeat 50%;
  background-size: cover;
  position: relative;
  @media screen and (max-width: 1100px) {
    .sp_login_introduce {
      display: none;
    }
  }

  @media screen and (min-width: 1100px) {
    .sp_login_introduce {
      display: block;
    }
  }
  .sp_login_introduce {
    position: absolute;
    top: 260px;
    left: 155px;
    width: 29%;
    h1 {
      font-size: 34px;
      line-height: 47px;
      color: #fff;
      font-weight: normal;
      width: 100%;
      margin-bottom: 30px;
    }
    p {
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }
  }
  .sp_fp_module {
    padding: 14px 24px;
    height: calc(100% - 20px);
    width: 700px;
    position: absolute;
    top: 10px;
    right: 10px;
    // transform: translate(0, -50%);
    background: #fff;
    border-radius: 6px;
    .sp-fp-content {
      height: calc(100% - 120px);
      display: flex;
      flex-direction: column;
      // align-items: center;
      overflow-y: auto;
      justify-content: center;
    }
    .footer-label {
      padding: 0 120px;
      // margin-top: 55px;
      .sp_login_copyRight {
        width: 400px !important;
        width: 100%;
        text-align: center;
        color: #a1a8b3;
        font-size: 14px;
        opacity: 0.8;
      }
    }
    .sp_logo {
      width: 100%;
      text-align: center;
      img {
        width: 60px;
      }
      p {
        text-align: center;
        color: #807d7d;
        font-size: 20px;
        font-weight: 600;
      }
    }
    .sp_passwordRetrieval {
      width: 100%;
      margin: 40px 0 32px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .title {
        width: 100%;
        text-align: center;
        color: #13161a;
        font-size: 28px;
        font-weight: 500;
      }
      .line {
        width: 52px;
        height: 4px;
        background: #007aff;
        margin-top: 10px;
      }
    }
    .sp_step {
      padding: 20px 120px 0 120px;
      min-height: 285px;
    }
    .step {
      font-size: 14px;
      font-weight: 500;
    }
    /deep/.el-step__arrow {
      font-size: 14px;
    }
    .isActive {
      /deep/.el-step__title.is-success {
        color: #007aff;
      }
    }
    /deep/.el-step__title.is-success {
      color: #666666;
    }
    /deep/.el-step__title.is-process {
      font-weight: normal;
      color: #666666;
    }
    /deep/.el-step__title.is-wait {
      color: #666666;
    }
  }
}
.el-steps {
  height: 40px;
}
/deep/.el-step.is-simple .el-step__title {
  font-size: 14px !important;
  font-weight: 500 !important;
}
</style>